// import APIs
import { getOpenRequests } from 'RestAPIs/roster/open-requests';

// import external libraries
import { useQuery } from 'react-query';

// constants
import { OPEN_REQUESTS_QUERY_KEY } from '../RosterPlan.consts';

export type GetOpenRequestsProps = {
  costCenters: string;
  startDate: string;
  endDate: string;
};

const useGetOpenRequests = (
  { costCenters, startDate, endDate }: GetOpenRequestsProps,
  options: Record<string, any> = {}
) => {
  const { data, isFetching, isError, refetch } = useQuery(
    [OPEN_REQUESTS_QUERY_KEY, costCenters, startDate, endDate],
    async () => {
      const { data } = await getOpenRequests({
        costCenters,
        startDate,
        endDate
      });
      return data;
    },
    options
  );
  return { data, isFetching, isError, refetch };
};

export default useGetOpenRequests;
